import { render, staticRenderFns } from "./LegendsOnHover.vue?vue&type=template&id=61904956&"
import script from "./LegendsOnHover.vue?vue&type=script&lang=js&"
export * from "./LegendsOnHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports